import { gql } from 'apollo-boost';

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($uuid_id: uuid!) {
    delete_products_by_pk(uuid_id: $uuid_id) {
      uuid_id
    }
  }
`;

export default gql`
  fragment filters on products {
    id
    crusher
    metso_id
    catalog_id
    description
    oem
    replace_quantity
    crusher_type
    brand
    group
  }

  query(
    $where: products_bool_exp
    $groupFilter: products_bool_exp
    $crusherFilter: products_bool_exp
    $crusherTypeFilter: products_bool_exp
    $brand: String
    $crusher_type: String
    $crusher: String
    $group: String
    $includesbrand: Boolean! = true
    $includescrusher_type: Boolean! = false
    $includescrusher: Boolean! = false
    $includesgroup: Boolean! = false
  ) {
    productsAggregate: products_aggregate(where: $where) {
      aggregate {
        count
      }
    }
    products(limit: 3000, where: $where) {
      uuid_id
      crusher
      metso_id
      catalog_id
      description
      oem
      replace_quantity
      crusher_type
      brand
      group
      related_products_as_target {
        id
      }
      ...filters
    }
    brand: products(distinct_on: [brand]) @include(if: $includesbrand) {
      id
      value: brand
    }
    crusher_type: products(
      distinct_on: [crusher_type]
      where: $crusherTypeFilter
    ) @include(if: $includescrusher_type) {
      id
      value: crusher_type
    }
    crusher: products(distinct_on: [crusher], where: $crusherFilter)
      @include(if: $includescrusher) {
      id
      value: crusher
    }
    group: products(distinct_on: [group], where: $groupFilter)
      @include(if: $includesgroup) {
      id
      value: group
    }
  }
`;
